import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {RecurringType} from "../../../commons/types/recurring.type";

export class UrgencyChargeComponent implements IController {
  program: any;
  programId: any;
  groups: any;
  accountId: any;

  public groupKeysCopy: any;
  public dowNames: any;
  // Calendar Init - View Types
  public views: string[] = ['agendaWeek', 'agendaDay'];
  //Calendar Init - This Week View
  public minDate: any;
  public maxDate: any;
  public isParent: boolean = false;
  public groupKeys: any;
  public isSaveAvailable: boolean;
  public dynamicTimeWindowsEnabled: boolean;
  public events: any;
  public isDesktop: boolean;
  public timeWindowOptions: number[];
  public largeTaskDurationHours: number;
  public largeTaskPercentage: number;
  public recurringType: any;
  public recurringInterval: any;
  public defaultDeliveryDays: any;
  public serviceAreaDeliveryDays: any[];
  public parentDefaultDeliveryDays: any;
  public parentServiceAreaDeliveryDays: any[];
  public selectedTab: string;

  get isLargeTaskFeatureEnabled(): boolean {
    return this.groupKeys?.TimeSlot?.QueryLargeTask?.enabled === true ||
      this.groupKeys?.TimeSlot?.QueryLargeTask?.parentEnabled === true;
  }

  constructor(private PricePlanService, private pricePlanDialogService: PricePlanDialogService, private IAMPermissions, private $mdMedia,
              private confirmDialogService: ConfirmDialogService, private commonsConstants, private splitService, private commonsDialogService: CommonsDialogService,
              private moment, private $filter, private commonsService: CommonsService, private pricePlanAlertsService: PricePlanAlertsService) {
    this.dowNames = this.commonsConstants.dayArray;
    this.minDate = this.moment().startOf('week');
    this.maxDate = this.moment().endOf('week');
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this.dynamicTimeWindowsEnabled = this.IAMPermissions.hasPermission('dynamicQuote.list');
    this.isSaveAvailable = false;

    this.ensureQueryLargeTaskInProgramData();

    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this.setDeliveryDaysRows();
    this.syncDeliveryDaysValue();
    this.groupKeysCopy = angular.copy(this.groupKeys);

    const parentRows = _.map(this.groupDeliveryDays(this.groupKeys.DeliveryDaysIndication.DeliveryDaysIndication.parentValue), (row) => ({
      ...row,
      daysText: this.getDaysString(row.eventSchedule.byWeekDay)
    }));
    const [parentDefaultRows, parentServiceAreaRows] = _.partition(parentRows, (row) => _.isEmpty(row.serviceAreaIds));
    this.parentDefaultDeliveryDays = parentDefaultRows[0];
    this.parentServiceAreaDeliveryDays = parentServiceAreaRows;

    var timeSlotValue = _.get(this.groupKeys, 'TimeSlot.TimeSlots.value');
    var parentTimeSlotValue = _.get(this.groupKeys, 'TimeSlot.TimeSlots.parentValue');
    this.isParent =
      (_.isUndefined(timeSlotValue) || !timeSlotValue.length) &&
      !_.isUndefined(parentTimeSlotValue);

    this.events = this.convertTimeSlotsToEvents(this.isParent ? parentTimeSlotValue : timeSlotValue, this.isParent);


    const arrLength = 23;
    const step = 0.5;
    this.timeWindowOptions = [...Array(Math.floor(arrLength / step) + 1).keys()].map((i) => (i + 1) * step);
    this.timeWindowOptions.push(24);

    // Initialize UI values from backend values
    this.syncUIValuesFromBackend();
  }


  onDataChange(groupKeys) {
    this.isSaveAvailable = !_.isEqual(groupKeys, this.groupKeysCopy);
  }

  onDeliveryDaysChange() {
    this.syncDeliveryDaysValue();
    this.onDataChange(this.groupKeys);
  }

  onFreeStyleMinRangeTimeWindowChange(groupKeys) {
    this.onDataChange(groupKeys);
  }

  onFreeStyleMaxRangeTimeWindowChange(groupKeys) {
    this.onDataChange(groupKeys);
  }

  onLargeTaskDurationChange() {
    if (this.groupKeys?.TimeSlot?.LargeTaskMinimumMinutes) {
      // Ensure we have a valid number, default to 5 hours if invalid
      // const hours = this.largeTaskDurationHours && this.largeTaskDurationHours >= 1
      //   ? parseInt(this.largeTaskDurationHours.toString(), 10)
      //   : 5;
      // this.groupKeys.TimeSlot.LargeTaskMinimumMinutes.value = hours * 60;

      const hours = Number(this.largeTaskDurationHours);

      this.groupKeys.TimeSlot.LargeTaskMinimumMinutes.value =
        this.largeTaskDurationHours == null ? undefined : hours * 60;
    }
    this.onDataChange(this.groupKeys);
  }

  onLargeTaskPercentageChange() {
    // Convert UI percentage to backend factor using inverse relationship
    // UI 30% = backend 0.7, UI 1% = backend 0.99
    if (this.groupKeys?.TimeSlot?.LargeTaskTimeWindowFactor) {
      // Ensure percentage is within valid range (1-100)

      let percentage =
        this.largeTaskPercentage == null
          ? undefined
          : parseFloat(this.largeTaskPercentage.toString());

      this.groupKeys.TimeSlot.LargeTaskTimeWindowFactor.value = _.isUndefined(percentage) ? undefined : 1 - (percentage / 100);
    }
    this.onDataChange(this.groupKeys);
  }

  private syncUIValuesFromBackend() {
    const minutes = this.groupKeys?.TimeSlot?.LargeTaskMinimumMinutes?.value;
    this.largeTaskDurationHours = minutes ? Math.floor(minutes / 60) : undefined;

    const factor = this.groupKeys?.TimeSlot?.LargeTaskTimeWindowFactor?.value;
    this.largeTaskPercentage = factor !== undefined && factor !== null ? Math.round((1 - factor) * 100) : undefined;
  }

  onSaveProgram() {
    // Validate large task configuration if QueryLargeTask is enabled
    if (!this.validateLargeTaskConfiguration()) {
      return;
    }

    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);

    const deliveryDaysSchedules = _.compact(_.map([this.defaultDeliveryDays, ...this.serviceAreaDeliveryDays], 'eventSchedule'));

    if (_.some(deliveryDaysSchedules, (schedule) => schedule.freq === RecurringType.WEEKLY && !schedule.byWeekDay?.length)) {
      this.pricePlanAlertsService.daysNotSelectedInfo();
      return;
    }

    if (_.some(deliveryDaysSchedules, (schedule) => !schedule.interval)) {
      this.pricePlanAlertsService.intervalNotSetInfo();
      return;
    }

    if (_.some(this.serviceAreaDeliveryDays, (row) => !row.serviceAreaIds.length)) {
      this.pricePlanAlertsService.serviceAreasNotSelectedInfo();
      return;
    }

    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        if (updatedProgram) {
          this.program = updatedProgram;
          this.$onInit();
        }
      })

  }

  getHeight() {
    const element = angular.element(document.querySelector('#content-container'));
    return element[0].clientHeight;
  }

  private validateLargeTaskConfiguration(): boolean {
    // Check if QueryLargeTask is enabled
    if (!this.isLargeTaskFeatureEnabled) {
      return true; // No validation needed if feature is disabled
    }

    // Validate LargeTaskMinimumMinutes (backend stores minutes, but validate UI hours input)
    const largeTaskMinutesValue = this.groupKeys?.TimeSlot?.LargeTaskMinimumMinutes?.value;
    const largeTaskMinutesParentValue = this.groupKeys?.TimeSlot?.LargeTaskMinimumMinutes?.parentValue;

    if (!largeTaskMinutesParentValue && (!largeTaskMinutesValue || largeTaskMinutesValue < 60)) { // At least 1 hour = 60 minutes
      this.commonsDialogService.infoDialog(
        'Validation Error',
        'Large task duration is required and must be at least 1 hour. Please enter a value of 1 or higher.'
      );
      return false;
    }

    // Validate LargeTaskTimeWindowFactor (backend stores factor, but validate reasonable range)
    const blockingFactorValue = this.groupKeys?.TimeSlot?.LargeTaskTimeWindowFactor?.value;
    const blockingFactorParentValue = this.groupKeys?.TimeSlot?.LargeTaskTimeWindowFactor?.parentValue;
    if (!blockingFactorParentValue && (blockingFactorValue === null || blockingFactorValue === undefined || blockingFactorValue <= 0 || blockingFactorValue > 1)) {
      this.commonsDialogService.infoDialog(
        'Validation Error',
        'Blocking percentage is required and must be between 1% and 100%. This determines how much of the task\'s time window to reserve.'
      );
      return false;
    }

    return true;
  }

  onCreateTimeSlot(event) {
    this.pricePlanDialogService.addTimeSlot(event)
      .then((timeSlotToAdd) => {
        if (!this.groupKeys.TimeSlot.TimeSlots.value) {
          this.groupKeys.TimeSlot.TimeSlots.value = [];
        }
        this.groupKeys.TimeSlot.TimeSlots.value.push(timeSlotToAdd);
        this.onSaveProgram();
      })
      .catch(() => {
      })
  }

  onEventClicked(event, $event) {
    const actions = !event.isParent ? ['Edit', 'Duplicate', 'Delete'] : ['Duplicate'];
    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Edit') {
          this.onEditTimeWindow(event, $event);
        }
        if (reason === 'Duplicate') {
          this.onDuplicateTimeWindow(event, $event);
        }
        if (reason === 'Delete') {
          this.onDeleteTimeWindow(event, $event);
        }
      })
      .catch((reason) => {
      });
  }

  onEventChange(event, delta, revertFunc) {

    const title = this.$filter('translate')('Move Event') + ' ' + this.$filter('translate')(_.get(event, 'title') ? _.get(event, 'title') : '');
    this.confirmDialogService.confirm(title, 'are you sure you want to move event?')
      .then(() => {
        event.start = this.moment(event.start.format());
        event.end = this.moment(event.end.format());

        const eventRefCopy = angular.copy(event.eventRef);

        eventRefCopy.startRecurring = event.start.valueOf();
        eventRefCopy.startHour = this.moment(event.start).hour();
        eventRefCopy.startMinute = this.moment(event.start).minute();
        eventRefCopy.totalDurationInMillis = event.end.valueOf() - event.start.valueOf();

        eventRefCopy.byWeekDay = [this.dowNames[event.start.day()].substring(0, 2)];

        let timeSlotsValueCopy = angular.copy(this.events);
        timeSlotsValueCopy[event.index].eventRef = eventRefCopy;
        timeSlotsValueCopy = _.map(timeSlotsValueCopy, (e) => {
          return e.eventRef;
        });

        this.groupKeys.TimeSlot.TimeSlots.value = timeSlotsValueCopy;
        this.onSaveProgram();
      })
      .catch((error) => {
        if (error) {
        } else {
          revertFunc();
        }
      })
  }

  onCalendarSelection(from, to, $event) {

    // If only clicked on calendar (less then an full hour)
    if (to.valueOf() - from.valueOf() <= 1800000) {
      return;
    }

    const format = this.splitService.getDateAndTimeConfig().time,
      title = 'Create Time Slot, ' + from.format(format) + ' - ' + to.format(format);

    this.confirmDialogService.confirm(title, 'Are you sure you want to create a new time slot?', $event)
      .then(() => {
        const timeSlotToCreate = this.commonsConstants.emptyEvent;
        timeSlotToCreate.timezone = this.splitService.getTimeZone();
        timeSlotToCreate.startRecurring = from.valueOf();
        timeSlotToCreate.startHour = this.moment(from).hour();
        timeSlotToCreate.startMinute = this.moment(from).minute();
        timeSlotToCreate.totalDurationInMillis = to.valueOf() - from.valueOf();

        timeSlotToCreate.byWeekDay = [this.dowNames[from.day()].substring(0, 2)];

        if (!this.groupKeys.TimeSlot.TimeSlots.value) {
          this.groupKeys.TimeSlot.TimeSlots.value = [];
        }
        this.groupKeys.TimeSlot.TimeSlots.value.push(timeSlotToCreate);
        this.onSaveProgram();
      })
      .catch((error) => {
        if (error) {
        }
      })
  }

  onRecurringChange(type) {
    if (!type) {
      this.defaultDeliveryDays.eventSchedule = undefined;
    } else if (!this.defaultDeliveryDays.eventSchedule) {
      this.defaultDeliveryDays.eventSchedule = {
        interval: 1,
        freq: type,
        timezone: this.splitService.getTimeZone(),
      };
    } else {
      this.defaultDeliveryDays.eventSchedule.freq = type;
    }

    this.onDeliveryDaysChange();
  }

  onAddServiceAreaRow() {
    this.serviceAreaDeliveryDays.push({
      serviceAreaIds: [],
      eventSchedule: {
        interval: 1,
        freq: RecurringType.WEEKLY,
        timezone: this.splitService.getTimeZone(),
        byWeekDay: _.keys(this.commonsConstants.daysCheckboxConfig)
      }
    });

    this.onDeliveryDaysChange();
  }

  onDeleteServiceAreaRow(index: number) {
    this.serviceAreaDeliveryDays.splice(index, 1);
    this.onDeliveryDaysChange();
  }

  onServiceAreaRowAreasChange(row, ids: string[]) {
    row.serviceAreaIds = ids;
    this.onDeliveryDaysChange();
  }

  onServiceAreaRowRecurringChange(row, type: string) {
    row.eventSchedule.freq = type;
    this.onDeliveryDaysChange();
  }

  // Backend stores one flat list: rows without serviceAreaIds are the default, the rest are per service area
  private setDeliveryDaysRows() {
    const [defaultRows, serviceAreaRows] = _.partition(this.groupDeliveryDays(this.groupKeys.DeliveryDaysIndication.DeliveryDaysIndication.value), (row) => _.isEmpty(row.serviceAreaIds));
    this.defaultDeliveryDays = defaultRows[0] || {serviceAreaIds: []};
    this.serviceAreaDeliveryDays = serviceAreaRows;
  }

  private syncDeliveryDaysValue() {
    const rows = _.filter([this.defaultDeliveryDays, ...this.serviceAreaDeliveryDays], 'eventSchedule');
    this.groupKeys.DeliveryDaysIndication.DeliveryDaysIndication.value = _.flatMap(angular.copy(rows), (row) => this.toBackendDeliveryDays(row));
  }

  // Merges the one-day rows the backend stores back into one row per service areas + frequency + interval
  private groupDeliveryDays(rows) {
    const groups = [];
    _.forEach(_.filter(rows, 'eventSchedule'), (row) => {
      const serviceAreaIds = _.sortBy(row.serviceAreaIds);
      const group = _.find(groups, (g) => _.isEqual(g.serviceAreaIds, serviceAreaIds) &&
        g.eventSchedule.freq === row.eventSchedule.freq && g.eventSchedule.interval === row.eventSchedule.interval);

      if (group) {
        group.eventSchedule.byWeekDay = _.union(group.eventSchedule.byWeekDay, row.eventSchedule.byWeekDay);
      } else {
        groups.push({serviceAreaIds, eventSchedule: angular.copy(row.eventSchedule)});
      }
    });
    return groups;
  }

  // With enforcement on, the backend accepts exactly one day per WEEKLY row
  private toBackendDeliveryDays(row) {
    const deliveryDays = _.isEmpty(row.serviceAreaIds) ? {eventSchedule: row.eventSchedule} : row;
    if (row.eventSchedule.freq !== RecurringType.WEEKLY || _.size(row.eventSchedule.byWeekDay) <= 1) {
      return [deliveryDays];
    }

    return _.map(row.eventSchedule.byWeekDay, (day) => ({
      ...deliveryDays,
      eventSchedule: {...row.eventSchedule, byWeekDay: [day]}
    }));
  }

  private getDaysString(byWeekDay: string[]): string {
    const dayNames = _.map(byWeekDay, (dayKey) => {
      return this.$filter('translate')('DAY_NAMES_SHORTCUT.' + dayKey);
    });

    return dayNames.join(', ');
  }


  onCancelChanges() {
    this.groupKeys = angular.copy(this.groupKeysCopy);
    this.setDeliveryDaysRows();
    this.isSaveAvailable = false;
  }

  // ******************************
  //        Private methods
  // ******************************

  private ensureQueryLargeTaskInProgramData() {
    // Find TimeSlot group in program data
    const timeSlotGroup = _.find(this.program.data, (group) => group.id === 'TimeSlot');

    if (timeSlotGroup && timeSlotGroup.value) {
      // Check if QueryLargeTask already exists
      const existingQueryLargeTask = _.find(timeSlotGroup.value, (item) => item.id === 'QueryLargeTask');

      if (!existingQueryLargeTask) {
        // Add default QueryLargeTask entry
        const defaultQueryLargeTask = {
          type: "Normal",
          group: "TimeSlot",
          dataType: "Boolean",
          id: "QueryLargeTask",
          description: "Prevent shifting large tasks switch",
          readOnly: false,
          parentEnabled: false,
          canDisable: false,
          state: "InheritedDisabled"
        };

        timeSlotGroup.value.push(defaultQueryLargeTask);
      }

      // Check and add LargeTaskMinimumMinutes if missing
      const existingDurationEntry = _.find(timeSlotGroup.value, (item) => item.id === 'LargeTaskMinimumMinutes');
      if (!existingDurationEntry) {
        const largeTaskDurationEntry = {
          type: "PricePlanDataEntry",
          group: "TimeSlot",
          dataType: "Long",
          id: "LargeTaskMinimumMinutes",
          description: "Large task duration in minutes",
          readOnly: false,
          state: "Inherited",
          canDisable: false,
          value: 300
        };

        timeSlotGroup.value.push(largeTaskDurationEntry);
      }

      // Check and add LargeTaskTimeWindowFactor if missing
      const existingFactorEntry = _.find(timeSlotGroup.value, (item) => item.id === 'LargeTaskTimeWindowFactor');
      if (!existingFactorEntry) {
        const largeTaskFactorEntry = {
          type: "PricePlanDataEntry",
          group: "TimeSlot",
          parentValue: 0,
          dataType: "Float",
          id: "LargeTaskTimeWindowFactor",
          description: "Large task time window factor",
          readOnly: false,
          state: "Inherited",
          canDisable: false,
          value: 0.7
        };

        timeSlotGroup.value.push(largeTaskFactorEntry);
      }
    }
  }

  private convertTimeSlotsToEvents(timeSlots, isParent) {
    if (!timeSlots) {
      timeSlots = [];
    }
    return _.map(timeSlots, (ts, index) => {
      return {
        index: index,
        isParent: isParent,
        color: isParent ? 'black' : undefined,
        eventRef: this.setEventRef(ts),
        title: isParent ? 'Parent' : undefined,
        start: ts.startHour ? this.getHour(ts.startHour, ts.startMinute) : ts.start, // a start time (10am in this example)
        end: ts.startHour ? this.getEndTime(ts.startHour, ts.startMinute, ts.byWeekDay, ts.totalDurationInMillis) : ts.end,
        dow: ts.dow,
        ranges: [{
          start: this.minDate, //This Week
          end: this.maxDate,
        }]
      }
    });
  }

  private setEventRef(ts) {
    return {
      byWeekDay: ts.byWeekDay,
      deleted: ts.deleted,
      dow: ts.dow,
      durationInMillis: !_.isUndefined(ts.durationInMillis) ? ts.durationInMillis : ts.totalDurationInMillis,
      freq: ts.freq,
      rrule: ts.rrule,
      startHour: !_.isUndefined(ts.startHour) ? ts.startHour : this.moment(ts.startTime).hour(),
      startMinute: !_.isUndefined(ts.startMinute) ? ts.startMinute : this.moment(ts.startTime).minute(),
      startRecurring: !_.isUndefined(ts.startRecurring) ? ts.startRecurring : ts.startTime,
      timezone: !_.isUndefined(ts.timezone) ? ts.timezone : this.splitService.getTimeZone(),
      totalDurationInMillis: !_.isUndefined(ts.totalDurationInMillis) ? ts.totalDurationInMillis : ts.durationInMillis
    }
  }

  private getHour(hour, minute) {
    return ("0" + hour).slice(-2) + ':' + ("0" + minute).slice(-2);
  }

  private getEndTime(startHour, startMin, startDay, duration) {
    let endTimeInTimeStamp = this.getTimeStamp(startHour, startMin, startDay) + duration;
    return this.moment(endTimeInTimeStamp).format('HH:mm');
  }

  private getTimeStamp(hour, min, day) {
    return this.moment().day(day).set({'hour': hour, 'minute': min, 'second': 0, 'millisecond': 0}).valueOf();
  }

  private onEditTimeWindow(event, $event) {
    let eventRef = this.setEventRef(event.eventRef);

    this.pricePlanDialogService.editTimeSlot(eventRef, $event)
      .then((editedTimeSlot) => {
        if (editedTimeSlot) {
          let timeSlotsValueCopy = angular.copy(this.events);
          timeSlotsValueCopy[event.index].eventRef = editedTimeSlot;
          timeSlotsValueCopy = _.map(timeSlotsValueCopy, (e) => {
            return e.eventRef;
          });

          this.groupKeys.TimeSlot.TimeSlots.value = timeSlotsValueCopy;
          this.onSaveProgram();
        }
      })
      .catch(() => {
      });
  }

  private onDuplicateTimeWindow(event, $event) {
    let eventRef = this.setEventRef(event.eventRef);

    this.pricePlanDialogService.duplicateTimeSlot(eventRef, event.isParent, $event)
      .then((timeSlotsToCreate) => {
        if (timeSlotsToCreate && timeSlotsToCreate.length) {
          if (!this.groupKeys.TimeSlot.TimeSlots.value) {
            this.groupKeys.TimeSlot.TimeSlots.value = [];
          }
          this.groupKeys.TimeSlot.TimeSlots.value = this.groupKeys.TimeSlot.TimeSlots.value.concat(timeSlotsToCreate);
          this.onSaveProgram();
        }
      })
      .catch(() => {
      });
  }

  private onDeleteTimeWindow(event, $event) {
    this.confirmDialogService.confirm('Delete Time Slot', 'Are you sure you want to delete slot?', $event)
      .then(() => {

        let timeSlotsValueCopy = angular.copy(this.events);
        timeSlotsValueCopy.splice(event.index, 1);
        timeSlotsValueCopy = _.map(timeSlotsValueCopy, (e) => {
          return e.eventRef;
        });

        this.groupKeys.TimeSlot.TimeSlots.value = timeSlotsValueCopy;
        this.onSaveProgram();
      })
      .catch((error) => {
        if (error) {
        }
      })
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanUrgencyChargeView', {
    bindings: {
      program: '<',
      programId: '<',
      groups: '<',
      accountId: '<?'
    },
    template: require('./urgency-charge.html').default,
    controller: UrgencyChargeComponent
  });
